import { useState } from 'react';
import { Row, Col, Input, Button } from 'antd';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { FormEditSummaryItem } from './FormEditSummaryItem';
import { useDictionaryTranslation } from '../../../../../hooks/useDictionaryTranslation';

const MultipleListInput = ({ value, onChange }) => {
  const { translate: t } = useDictionaryTranslation();
  const getValues = (newValue) => newValue?.map((items) => items.join(' > ')) ?? [''];
  const [currentItems, setCurrentItems] = useState(getValues(value));

  const notifyChange = (newValue) => {
    const newItems = [];
    for (const item of newValue) {
      const data = item?.trim();
      if (data) {
        newItems.push(data.split(' > ').map((newItem) => newItem.trim()));
      }
    }
    onChange(newItems);
  };

  const handleChangeItemValue = (itemIndex) => (e) => {
    const newValue = e.target.value;
    setCurrentItems((current) => {
      const newValues = current.map((item, index) => {
        if (index === itemIndex) {
          return newValue;
        }
        return item;
      });
      notifyChange(newValues);
      return newValues;
    });
  };

  const handleAddInput = () => {
    setCurrentItems((current) => [...current, '']);
  };

  const handleRemoveItem = (itemIndex) => () => {
    setCurrentItems((current) => {
      const newValues = current.filter((_, index) => index !== itemIndex);
      notifyChange(newValues);
      return newValues;
    });
  };

  return (
    <Row gutter={[10, 30]}>
      <Col xs={24}>
        <Row gutter={[10, 25]}>
          {currentItems.map((item, index) => {
            return (
              <Col xs={24}>
                <Row key={index}>
                  <Col xs={23}>
                    <Input value={item} onChange={handleChangeItemValue(index)} />
                  </Col>
                  <Col key={index} xs={1}>
                    <Button danger shape="circle" type="text" onClick={handleRemoveItem(index)}>
                      <FeatherIcon icon="x" />
                    </Button>
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Col>

      <Col xs={24}>
        <Row justify="end">
          <Button type="primary" onClick={handleAddInput}>
            {t('add')}
          </Button>
        </Row>
      </Col>
    </Row>
  );
};

export const EditSummaryMultipleListItem = ({ field, onFinish }) => {
  return (
    <FormEditSummaryItem field={field} onFinish={onFinish} showActionsInTitle>
      <MultipleListInput />
    </FormEditSummaryItem>
  );
};

EditSummaryMultipleListItem.propTypes = {
  field: PropTypes.shape({
    value: PropTypes.array,
  }),
  onFinish: PropTypes.func,
};

MultipleListInput.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
};
